/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Menu, Dropdown } from "antd";
import { connect } from "react-redux";
import {
	LogoutOutlined,
	UserOutlined,
	CrownOutlined,
	QuestionCircleOutlined,
	TeamOutlined,
	BulbOutlined,
} from "@ant-design/icons";
import Icon from "components/util-components/Icon";
import { signOut } from "redux/actions/Auth";
import { onSwitchTheme } from "redux/actions/Theme";
import CroppedAvatar from "components/atom/CroppedAvatar";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import useIsAppWebView from "hooks/useIsAppWebView";

const menuItem = [];

export const NavProfile = ({
	signOut,
	user,
	isMobile,
	currentTheme,
	onSwitchTheme,
}) => {
	const history = useHistory();
	const isAppWebView = useIsAppWebView();

	// Verificar se é funcionário
	const isFuncionario =
		user.funcionario_info && user.funcionario_info.e_funcionario;

	const abrirTelaDadosConta = async () => {
		history.push(`${APP_PREFIX_PATH}/dados-conta`);
	};

	const abrirTelaAssinatura = async () => {
		history.push(`${APP_PREFIX_PATH}/assinatura`);
	};

	const abrirTelaSuporte = async () => {
		history.push(`${APP_PREFIX_PATH}/suporte`);
	};

	const abrirTelaIndicacoes = async () => {
		history.push(`${APP_PREFIX_PATH}/indicacoes`);
	};

	const profileMenu = (
		<div className="nav-profile nav-dropdown">
			{/* <div className="nav-profile-header">
				<div className="d-flex">
					<UserOutlined style={{ fontSize: 45 }} />
					<div className="pl-3">
						<h4 className="mb-0">{user.name}</h4>
						<span className="text-muted">{user.role}</span>
					</div>
				</div>
			</div> */}
			<div className="nav-profile-body">
				<Menu style={{ boxShadow: "none" }}>
					{menuItem.map((el, i) => {
						return (
							<Menu.Item key={i}>
								<a href={el.path}>
									<Icon className="mr-3" type={el.icon} />
									<span className="font-weight-normal">
										{el.title}
									</span>
								</a>
							</Menu.Item>
						);
					})}

					{/* <Menu.Item key={0}>
						<a onClick={() => requestCacheService.limparCache()}>
							<ClearOutlined className="mr-3" />
							<span className="font-weight-normal">
								Limpar cache
							</span>
						</a>
					</Menu.Item> */}

					{/* Mostrar opções diferentes para funcionários vs profissionais */}
					{!isFuncionario && (
						<>
							<Menu.Item key={1}>
								<a onClick={() => abrirTelaDadosConta()}>
									<UserOutlined className="mr-3" />
									<span className="font-weight-normal">
										Conta
									</span>
								</a>
							</Menu.Item>

							{!isAppWebView && (
								<Menu.Item key={2}>
									<a onClick={() => abrirTelaAssinatura()}>
										<CrownOutlined className="mr-3" />
										<span className="font-weight-normal">
											Assinatura
										</span>
									</a>
								</Menu.Item>
							)}

							{user.tem_acesso_programa_indicacao && (
								<Menu.Item key={3}>
									<a onClick={() => abrirTelaIndicacoes()}>
										<TeamOutlined className="mr-3" />
										<span className="font-weight-normal">
											Programa de indicações
										</span>
									</a>
								</Menu.Item>
							)}
						</>
					)}

					<Menu.Item key={4}>
						<a onClick={() => abrirTelaSuporte()}>
							<QuestionCircleOutlined className="mr-3" />
							<span className="font-weight-normal">Suporte</span>
						</a>
					</Menu.Item>

					{isMobile && (
						<Menu.Item key="tema">
							<a
								onClick={() =>
									onSwitchTheme(
										currentTheme === "dark"
											? "light"
											: "dark",
									)
								}
							>
								<BulbOutlined className="mr-3" />
								<span className="font-weight-normal">
									{currentTheme === "dark"
										? "Modo claro"
										: "Modo escuro"}
								</span>
							</a>
						</Menu.Item>
					)}

					{!isAppWebView && (
						<Menu.Item key={5} onClick={(e) => signOut()}>
							<span>
								<LogoutOutlined className="mr-3" />
								<span className="font-weight-normal">Sair</span>
							</span>
						</Menu.Item>
					)}
				</Menu>
			</div>
		</div>
	);

	return (
		<div
			style={{
				display: "flex",
				alignItems: "center",
			}}
		>
			<Dropdown
				placement="bottomRight"
				overlay={profileMenu}
				trigger={["click"]}
				className={`nav-profile-dropdown${user.foto_perfil ? " nav-profile-dropdown-foto" : ""}`}
			>
				{user.foto_perfil ? (
					<div className="nav-profile-dropdown-foto" style={{ cursor: "pointer" }}>
						<CroppedAvatar
							fotoPerfil={user.foto_perfil}
							size={40}
							nome={user.name}
							style={{ cursor: "pointer" }}
						/>
					</div>
				) : (
					<Menu className="d-flex align-item-center" mode="horizontal">
						<Menu.Item className="user-header-icon" key="profile">
							<div className="user-header-icon-svg">
								<UserOutlined className="nav-icon mr-0" />
							</div>
						</Menu.Item>
					</Menu>
				)}
			</Dropdown>
			{/* <style>
				{`
					@keyframes pulse {
						0% {
							box-shadow: 0 0 0 0 rgba(255, 77, 79, 0.4);
						}
						70% {
							box-shadow: 0 0 0 10px rgba(255, 77, 79, 0);
						}
						100% {
							box-shadow: 0 0 0 0 rgba(255, 77, 79, 0);
						}
					}
				`}
			</style> */}
		</div>
	);
};

const mapStateToProps = ({ user, theme }) => {
	return {
		user: { ...user },
		currentTheme: theme.currentTheme,
	};
};

export default connect(mapStateToProps, { signOut, onSwitchTheme })(NavProfile);
